import React, { Component } from 'react';
import {connect} from "react-redux";
import CurrencyInput from 'react-currency-input';
import getLogoBranding from "utils/getLogoBranding.js"

class ReportView extends Component {
/*  constructor(props) {
    super(props);
  }*/

  renderTotalAmount(asd){
    let tot = asd.assetTotalValue.map((val, index) => { 
      return (
        <div className="report-subheader" key={index}>
          <div className="report-subheader-space">
            <h7>
              AMOUNT IN {val.Currency} :
              <span style={{ color : 'red'}}>
                <CurrencyInput
                  style={{'border': 'none','background': 'transparent', width: '110px', 'color': 'red', 'textAlign': 'right'}}
                  value  ={val.Amount}
                  readOnly
                />
              </span>
            </h7>
          </div>
          <div className="report-subheader-space" style={{'marginLeft': '16px', 'minWidth': '94px'}}>
            <h7>ASSETS : <span style={{ color : 'red', 'float': 'right'}}>{val.Count}</span></h7>
          </div>
        </div>
      )
    })
    return tot
  }
  render() {
    return (
      <div className="card-block">
        <div className="row">
          <div className="report-header">
            <h3>Asset Value Report</h3>
          </div>
          <div className="col-md-6 flex-align-center">
            <div className="logo-report-top-left">

              <img
                src={getLogoBranding("report", this.props.TenantReducer.report)}
                alt="Report Logo"/>
            </div>
          </div>
          <div className="col-md-6">
            {this.renderTotalAmount(this.props.state)}
            <div className="report-subheader">
              <div className="report-subheader-space" style={{'marginLeft': '10px', 'minWidth': '138px'}}>
                <h7>TOTAL ASSETS : <span style={{ color : 'red', 'float': 'right'}}>{this.props.state.countReport}</span></h7>
              </div>
            </div>
          </div>

        </div>
        <div className="report-body" style={{'fontSize': '12px'}}>
          <div className="row table-custome-report">
            <table className="table table-responsive table-bordered table-report table-striped table-sm mb-0 m-top-15 over-x">
              <thead>
                <tr>
                <th>Asset</th>
                <th>Asset Description</th>
                <th>Tag</th>
                <th>Status</th>
                <th>Type</th>
                <th>Assigned To</th>
                <th>Site</th>
                <th>Location</th>
                <th>Purchased By</th>
                <th>Purchased Date</th>
                <th>PO #</th>
                <th className="align-right">Value</th>
                </tr>
              </thead>
              <tbody>
                {this.props.children}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    TenantReducer: state.TenantReducer,
  }
}
export default connect(mapStateToProps)(ReportView)



// WEBPACK FOOTER //
// ./src/App/report/helper/component/Report/ReportView.js